/* Broadcast uses is-open; let Judge.me's native cart widget observe that state. */
(() => {
  const bind = () => {
    const drawer = document.querySelector('cart-drawer#cart-drawer');
    if (!drawer || drawer.dataset.lgJudgeCartBound) return;
    drawer.dataset.lgJudgeCartBound = 'true';
    const body = drawer.querySelector('.drawer__body');
    if (!body) return;
    const slot = document.createElement('div');
    slot.className = 'cart-drawer__content lg-cart-reviews';
    slot.setAttribute('aria-label', 'Customer reviews');
    body.appendChild(slot);
    const sync = () => drawer.toggleAttribute('open', drawer.classList.contains('is-open'));
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();